import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BASE_URL;
// Login user thunk

export const userProfile = createAsyncThunk(
  "user/userProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/profile`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      console.log(error, "error");
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);
export const loginUser = createAsyncThunk(
  "user/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/user/login`, credentials);

      // Set token cookie
      Cookies.set("token", response?.data?.message);

      // Return response data to the fulfilled reducer
      return response.data;
    } catch (err) {
      // Return error to the rejected reducer
      return rejectWithValue(err.response?.data?.message || "Login failed");
    }
  }
);
export const userProfileedit = createAsyncThunk(
  "user/userProfileedit",
  async (data, { rejectWithValue }) => {
    try {
      let bodyContent = new FormData();
      bodyContent.append("fullName", data?.fullName);
      bodyContent.append("userName", data?.userName);
      bodyContent.append("email", data?.email);
      bodyContent.append("image", data?.image);
      bodyContent.append("gender", data?.gender);
      bodyContent.append("dob", data?.dob);
      bodyContent.append("phoneNumber", data?.phoneNumber);
      bodyContent.append("country", data?.country);
      bodyContent.append("state", data?.state);
      bodyContent.append("city", data?.city);
      bodyContent.append("image", data?.profileImage);
      //   const response = await loginUserAPI(credentials);
      const response = await axios.put(
        `${BASE_URL}/user/profile/${data.id}`,
        bodyContent,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      // swal({
      //   title: "Edit profile  Successful",
      //   text: "You have successfully Edit profile in!",
      //   icon: "success",
      //   position: "top",
      //   timer: 3000,
      // });
      // window.location.href = "http://localhost:3000/dashboards/app/profile";
      return response;
    } catch (error) {
      console.log(error, "error");
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

// Register user thunk
export const registerUser = createAsyncThunk(
  "user/register",
  async (userData, { rejectWithValue }) => {
    console.log(userData, "USERDATA");

    try {
      const response = await axios.post(
        `${BASE_URL}/user/register`,
        userData
      );
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);

//facebook login
export const initiateFacebookLogin = createAsyncThunk(
  "auth/initiateFacebookLogin",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("token");
      const authUrl = `${BASE_URL}/user/auth/facebook?token=${encodeURIComponent(token)}`;

      // Simulate a redirect (this won't return to the thunk but allows loading state updates before redirect)
      window.location.href = authUrl;

      return true;
    } catch (error) {
      console.error("Facebook login initiation failed:", error);
      return rejectWithValue("Failed to initiate Facebook login");
    }
  }
);


// Instagram login
export const initiateInstagramLogin = () => {
  try {
    const token = Cookies.get("token");
    const authUrl = `${BASE_URL}/user/auth/instagram?token=${encodeURIComponent(
      token
    )}`;
    window.location.href = authUrl;
  } catch (error) {
    console.log(error, "internal server error");
  }
};
export const initiateLinkedinLogin = () => {
  try {
    const token = Cookies.get("token");
    const authUrl = `${BASE_URL}/user/auth/linkedin?token=${encodeURIComponent(
      token
    )}`;
    window.location.href = authUrl;
  } catch (error) {
    console.log(error, "internal server error");
  }
};

//whatsapp login
export const initiatewhatsappLogin = () => {
  try {
    const token = Cookies.get("token");
    const authUrl = `${BASE_URL}/user/auth/whatsapp?token=${encodeURIComponent(
      token
    )}`;
    window.location.href = authUrl;
  } catch (error) {
    console.log("internal server error ", error);
  }
};



export const reqResetPassword = createAsyncThunk(
  "user/reqResetPassword",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/requestPasswordReset`,
        {
          email: values.email,
        }
      );
      console.log(response, "-----------reset password---------");
      return response.data;
    } catch (error) {
      console.error("Password reset error:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during password reset";
      return rejectWithValue(errorMessage);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data, { rejectWithValue }) => {
    console.log(data, " id, password");
    try {
      const response = await axios.post(
        `${BASE_URL}/user/reset-password/${data?.id}`,
        {
          password: data?.password,
        }
      );
      console.log(response, "this sdsd");
      // Return the response for further handling if needed
      return response.data;
    } catch (error) {
      console.log(error, "error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during password reset";
      return rejectWithValue(errorMessage);
    }
  }
);
export const  changePassword = createAsyncThunk(
  "auth/ChangePassword",
  async (data, { rejectWithValue }) => {
    console.log(data, " id, password");
    try {
      const response = await axios.post(
        `${BASE_URL}/user/change-password `,data, {
          headers: {
            Authorization: `Bearer ${ Cookies.get("token")}`,
          },
        }
      );
   
      // If the request is successful, show a success message
      // if (response.status === 200) {
      //   swal({
      //     title: "Password Reset Successful",
      //     text: "Your password has been successfully reset!",
      //     icon: "success",
      //     position: "top",
      //     showConfirmButton: false,
      //     timer: 3000,
      //   });
      // }

      // Return the response for further handling if needed
      return response.data;
    } catch (error) {
      console.log(error, "error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during password reset";
      return rejectWithValue(errorMessage);
    }
  }
);

export const twoFaSetup = createAsyncThunk(
  "user/twoFaSetup",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("token");
      const response = await axios.get(
        `${BASE_URL}/user/auth/2fa/setup`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Setup 2FA Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const twoFaVerify = createAsyncThunk(
  "user/twoFaVerify",
  async (otp, { rejectWithValue }) => {
    try {
      const token = Cookies.get("token");
      console.log(otp, "------------");
      const response = await axios.post(
        `${BASE_URL}/user/auth/2fa/verify`,
        { token: otp },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(
        response,
        "---------------responseresponseresponseresponsevvvvvvvvvv-----------"
      );

      return response?.data;
    } catch (error) {
      console.error("Verify 2FA Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const disable2FA = createAsyncThunk(
  "user/disable2FA",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("token");
      const response = await axios.get(
        `${BASE_URL}/user/auth/2fa/disable`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response?.data);
      return response?.data;
    } catch (error) {
      console.error("Disable 2FA Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const googlewithlogin = () => {
  try {
    const authUrl = `${BASE_URL}/user/auth/google`;
    window.location.href = authUrl;
  } catch (error) {
    console.log(error, "internal server error");
  }
};
export const handleGoogleMeetingConnect = () => {
  try {
     const token = Cookies.get("token");
    window.location.href = `${BASE_URL}/user/auth/google-meeting?token=${token}`;
  } catch (error) {
    console.log(error, "internal server error");
  }
};

export const twitterwithlogin = () => {
  try {
    const authUrl = `${BASE_URL}/user/auth/twitter`;
    window.location.href = authUrl;
  } catch (error) {
    console.log(error, "internal server error");
  }
}
export const microsoftwithlogin = () => {
  try {
    const authUrl = `${BASE_URL}/user/auth/microsoft`;
    window.location.href = authUrl;
  } catch (error) {
    console.log(error, "internal server error");
  }
}

export const googlelogout = () => {
  try {
    axios.get(`${BASE_URL}/user/google/logout`, {
      headers: {
        Authorization: `Bearer ${Cookies.get("token")}`,
      },
    });
    Cookies.remove('token')
    Cookies.remove('twofatoken')
  } catch (error) {
    console.log(error, "internal server error");
  }
};

export const verifyOtp = createAsyncThunk(
  "user/verifyOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data, "data")
      const response = await axios.post(`${BASE_URL}/user/verify`, {
        email: data.email,
        otp: data?.otp
      });

      
      return response.data;
    } catch (error) {
      console.error("OTP verification error:", error);
      return rejectWithValue(error.response?.data.message || "Verification failed");
    }
  }
);

export const resendOtp = createAsyncThunk(
  'otp/resendOtp',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/user/resend-otp`, { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message); // handle errors
    }
  }
);